import styled from 'styled-components/macro';

export const Error = styled.span<{ checkbox?: boolean; isPassword?: boolean }>`
  color: ${({ theme }) => theme.colors.negative_dark};

  font-size: ${({ theme }) => theme.fontSize.xxs};
  line-height: ${({ theme }) => theme.lineHeight.zero_3};
`;
